import { Component, Input, OnInit, inject } from '@angular/core';
import { InboundCall } from 'app/core/models/inbound-call.model';
import { Patient } from 'app/core/models/patient.model';
import { InboundCallsService } from 'app/core/services/inbound-calls.service';
import { keyedReasonOptions } from 'app/core/options/inbound-call-reasons.opts';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { OfficeComponent } from '../../../shared/components/office/office.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-patient-inbound-calls',
    templateUrl: './patient-inbound-calls.component.html',
    styleUrls: ['./patient-inbound-calls.component.scss'],
    imports: [RouterLink, OfficeComponent, MatProgressSpinner, DatePipe]
})
export class PatientInboundCallsComponent implements OnInit {
  private inboundCallsService = inject(InboundCallsService);

  @Input() patient: Patient;

  loading = true;
  inboundCalls: InboundCall[] = [];

  keyedInboundCallReasonOptions = keyedReasonOptions;

  ngOnInit() {
    this.inboundCallsService
      .getList(1, 10, [], null, null, this.patient.id)
      .subscribe(results => {
        this.loading = false;
        this.inboundCalls = results.inboundCalls;
    });
  }
}
